import { ViewModel,View } from "binder"
import { ElementDecorator } from "../../element";
import { CompactView } from "./compact-view";
import  { DragableElementDecoratorView } from "./dragableElementDecorator-view"

export class DragableElementDecoratorViewModel  extends ElementDecorator{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    }
    GetDefaultView(): View <ViewModel> {
        return new DragableElementDecoratorView();
    }
    public getTypeId(): string {
        return "VM-C701BFBA-8F9F-40C4-804D-2401C18C73F1"
    }

    getCompactViewForFormBuilderStructureViewDecorators(vm){
        return new CompactView();
    }

}
